<template>

    <div class="help__overlay" v-show="show">

        <div class="help">

            <div>

                <div class="help__header">
                    <img src="/img/newsletters-v2/x-blue.svg" class="img__24" @click="close">
                </div>

                <markdown :text="infos.title"
                          class="text-lSemibold help__title mt__24"
                          :color="infos.color"
                ></markdown>

            </div>

            <div>

                <img :src="infos.image" class="help__card" v-show="!isDesktop">

                <div class="help__icons mt__32"
                     v-show="isDesktop"
                     :class="{
                        'help__icons__unsubscribes': step === ENUM.STEPS.HELP.UNSUBSCRIBES,
                        'help__icons__delete': step === ENUM.STEPS.HELP.DELETE,
                        'help__icons__keep': step === ENUM.STEPS.HELP.KEEP
                    }">
                    <img :src="infos.icon1" class="img__32">
                    <img :src="infos.icon2"
                         class="img__32"
                         :class="{
                            'help__icon__unsubscribes': step === ENUM.STEPS.HELP.UNSUBSCRIBES,
                            'help__icon__delete': step === ENUM.STEPS.HELP.DELETE,
                            'help__icon__keep': step === ENUM.STEPS.HELP.KEEP
                        }">
                </div>

            </div>

            <div>

                <img :src="infos.navigation" class="help__navigation">

                <button class="ds__button__medium ds__button__secondary ds__button__fluid text-lSemibold mt__24"
                        @click="next">
                    {{ $t(infos.cta) }}
                </button>

            </div>

        </div>

    </div>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

import Markdown from '@/components/Markdown'

export default {

    name: 'help',

    components: {
        Markdown
    },

    computed: {

        ENUM() {
            return ENUM
        },

        infos() {
            switch (this.step) {
                case ENUM.STEPS.HELP.UNSUBSCRIBES:
                    return {
                        title: this.$t('slide_left'),
                        image: '/img/newsletters-v2/help/autodelete.svg',
                        navigation: '/img/newsletters-v2/help/1_3.svg',
                        color: '#f04871',
                        icon1: '/img/newsletters-v2/help/arrow-left.svg',
                        icon2: '/img/newsletters-v2/help/delete-auto.svg',
                        cta: 'global_cta_next'
                    }
                case ENUM.STEPS.HELP.DELETE:
                    return {
                        title: this.$t('slide_up'),
                        image: '/img/newsletters-v2/help/delete.svg',
                        navigation: '/img/newsletters-v2/help/2_3.svg',
                        color: '#ec7423',
                        icon1: '/img/newsletters-v2/help/arrow-up.svg',
                        icon2: '/img/newsletters-v2/help/delete-simple.svg',
                        cta: 'global_cta_next'
                    }
                case ENUM.STEPS.HELP.KEEP:
                    return {
                        title: this.$t('slide_right'),
                        image: '/img/newsletters-v2/help/keep.svg',
                        navigation: '/img/newsletters-v2/help/3_3.svg',
                        color: '#00d191',
                        icon1: '/img/newsletters-v2/help/archive-i-os.svg',
                        icon2: '/img/newsletters-v2/help/arrow-right.svg',
                        cta: 'global_cta_understood'
                    }
                default:
                    return {}
            }
        }
    },

    data() {
        return {
            show: false,
            step: ''
        }
    },

    methods: {
        open() {
            Tag.clickGA(this, 'help')
            this.init()
            this.next()
            this.show = true
        },

        close() {
            this.show = false
        },

        init() {
            this.step = ''
        },

        next() {
            switch (this.step) {
                case ENUM.STEPS.TUTO.UNSUBSCRIBES:
                    Tag.clickGA(this, 'next')
                    this.step = ENUM.STEPS.TUTO.DELETE
                    Tag.pageViewGA(this, 'cleaning_tuto_bs_2')
                    break
                case ENUM.STEPS.TUTO.DELETE:
                    Tag.clickGA(this, 'next')
                    this.step = ENUM.STEPS.TUTO.KEEP
                    Tag.pageViewGA(this, 'cleaning_tuto_bs_3')
                    break
                case ENUM.STEPS.TUTO.KEEP:
                    Tag.clickGA(this, 'understood')
                    this.close()
                    this.step = ''
                    break
                default:
                    this.step = ENUM.STEPS.TUTO.UNSUBSCRIBES
                    Tag.pageViewGA(this, 'cleaning_tuto_bs_1')
            }
        },

    }
}
</script>

<style lang="scss" scoped>

.help {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    background-color: $white;
    border-radius: 16px;
    flex: 1;
    justify-content: space-between;
    @media screen and (min-width: $above-tablet-length) {
        width: 432px;
        padding: 24px;
        box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.05);
    }

    &__overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.16);
        display: flex;
        padding: 21px 16px;
        z-index: 1;
        @media screen and (min-width: $above-tablet-length) {
            top: initial;
            left: initial;
            right: 32px;
            bottom: 32px;
            padding: 0;
            background-color: inherit;
        }
    }

    &__header {
        display: flex;
        justify-content: flex-end;
    }

    &__card {
        margin-top: 24px;
    }

    &__navigation {
        margin-top: 24px;
        height: 10px;
        object-fit: contain;
    }

    &__icons {
        padding: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.05);
        border: solid 4px;

        &__unsubscribes {
            border-color: #fbc5d2;
            background-color: $raspberry;
        }

        &__delete {
            border-color: #f9d3b9;
            background-color: $sunset;
            flex-direction: column;
        }

        &__keep {
            border-color: #aef1dc;
            background-color: $lime;
        }
    }

    &__icon {

        &__unsubscribes {
            margin-left: 8px;
        }

        &__delete {
            margin-top: 8px;
        }

        &__keep {
            margin-left: 8px;
        }
    }
}

</style>
